import React from 'react';
import { useChat, LendiMemberType } from '../../../twilio';
import { useChatDataExposureContext } from '..';
/**
 * This component intent to provide online status and read notification out of the box so that <ChatProvider> can be given at the deep level where it is required.
 * And if anything else is needed from `useChat`, those are getting exposed via this component.
 */
export var ChatDataExposer = function (_a) {
    var _b, _c;
    var children = _a.children, userType = _a.userType;
    var _d = useChat(), hasNew = _d.hasNew, members = _d.members;
    // TODO: will this work when it is run as Team view
    var isOtherUserOnline;
    if (userType === 'customer') {
        isOtherUserOnline = ((_b = members.find(function (member) { return member.type === LendiMemberType.TEAM; })) === null || _b === void 0 ? void 0 : _b.isOnline) || false;
    }
    else if (userType === 'broker') {
        isOtherUserOnline = ((_c = members.find(function (member) { return member.type === LendiMemberType.CUSTOMER; })) === null || _c === void 0 ? void 0 : _c.isOnline) || false;
    }
    else {
        isOtherUserOnline = false;
    }
    var _e = useChatDataExposureContext(), setStatus = _e.setStatus, setHasUnReadMessage = _e.setHasUnReadMessage;
    React.useEffect(function () {
        setStatus && setStatus(isOtherUserOnline);
    }, [isOtherUserOnline]);
    React.useEffect(function () {
        setHasUnReadMessage && setHasUnReadMessage(hasNew);
    }, [hasNew]);
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=index.js.map